var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalendar({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.2857 2H12.5714V0.375C12.5714 0.16875 12.3786 0 12.1429 0H10.7143C10.4786 0 10.2857 0.16875 10.2857 0.375V2H5.71429V0.375C5.71429 0.16875 5.52143 0 5.28571 0H3.85714C3.62143 0 3.42857 0.16875 3.42857 0.375V2H1.71429C0.767857 2 0 2.67188 0 3.5V14.5C0 15.3281 0.767857 16 1.71429 16H14.2857C15.2321 16 16 15.3281 16 14.5V3.5C16 2.67188 15.2321 2 14.2857 2ZM14.0714 14.5H1.92857C1.81071 14.5 1.71429 14.4156 1.71429 14.3125V5H14.2857V14.3125C14.2857 14.4156 14.1893 14.5 14.0714 14.5Z",
    fill: "#C62B1E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.d8fdefffbf417161116a5f5773e98342.svg";
export { ForwardRef as ReactComponent };